import { fetchApi } from "infrastructure/api";
import type { Entity, ID } from "types";
import { HttpVerb } from "consts/api";
import { ApiRoutes } from "consts/enpoints/api";
import type {
    OnboardingApplication,
    OnboardingBankingAndFinance,
    OnboardingBusinessInformation,
    OnboardingMediaAndComplianceCheck,
    OnboardingPaymentMethod,
    OnboardingRequestParams,
    PreApplicationOnboarding,
    ResendPreapplicationVerifyLink,
    WithCompletion,
    WithUser
} from "./types";

export const getOnboardingUserById = (userId: ID) =>
    fetchApi(ApiRoutes.GetOnboardingsUsers(userId));

export const getOnboardingsConstants = () =>
    fetchApi(ApiRoutes.GetOnboardingsConstants());

export const getOnboardingsCountries = (query = '') =>
    fetchApi(`${ApiRoutes.GetOnboardingsCountries()}${query}`);

export const getOnboardingsPaymentMethods = (query = '') =>
    fetchApi(`${ApiRoutes.GetOnboardingsPaymentMethods()}${query}`);

export const postOnboardingRegister = (body: Partial<PreApplicationOnboarding>) =>
    fetchApi(ApiRoutes.PostOnboardingsRegister, {
        method: HttpVerb.Post,
        body
    });
export const resendPreapplicationVerifyLink = (body: ResendPreapplicationVerifyLink) =>
    fetchApi(ApiRoutes.ResendOnboardingRegistrationVerificationLink, {
        method: HttpVerb.Post,
        body
    });

export const getOnboardingsApplications = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsApplications(userId));

export const putOnboardingsApplications = (body: OnboardingRequestParams & Partial<OnboardingApplication>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsApplications(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const postOnboardingsApplications = (body: OnboardingRequestParams & Partial<OnboardingApplication>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PostOnboardingsApplications(userId), {
        method: HttpVerb.Post,
        body
    });
};

export const getOnboardingsBusinessInformationSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsBusinessInformationSteps(userId));

export const putOnboardingsBusinessInformationSteps = (body: OnboardingRequestParams & Partial<OnboardingBusinessInformation>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsBusinessInformationSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getOnboardingsBillingFinanceSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsBillingFinanceSteps(userId));

export const putOnboardingsBillingFinanceSteps = (body: OnboardingRequestParams & Partial<OnboardingBankingAndFinance>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsBillingFinanceSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getOnboardingsMediaComplianceSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsMediaComplianceSteps(userId));

export const putOnboardingsMediaComplianceSteps = (body: OnboardingRequestParams & Partial<OnboardingMediaAndComplianceCheck>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsMediaComplianceSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getOnboardingsIdentityVerificationSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsIdentityVerificationSteps(userId));

export const putOnboardingsIdentityVerificationSteps = (body: OnboardingRequestParams & WithCompletion) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsIdentityVerificationSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

// export const putOnboardingsUboIdentities = (body: OnboardingRequestParams & Partial<UboIdentity>) => {
//     const { userId } = body;

//     return fetchApi(ApiRoutes.PutOnboardingsUboIdentities(userId), {
//         method: HttpVerb.Put,
//         body
//     });
// };

export const deleteOnboardingsUboIdentities = ({ userId, pki }: WithUser & Entity) =>
    fetchApi(ApiRoutes.DeleteOnboardingsUboIdentities(userId, pki), {
        method: HttpVerb.Delete
    });

export const getOnboardingsPaymentMethodsSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsPaymentMethodsSteps(userId));

export const putOnboardingsPaymentMethodsSteps = (body: OnboardingRequestParams & Partial<OnboardingPaymentMethod>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsPaymentMethodsSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};
